
<template>
  <div id="menu">
    <!--     <a v-on:click="proj" class="menuItem">Projects</a>
    <a href="e" class="menuItem">About</a>-->
    <a href="resume.pdf" target="_blank" class="menuItem">Resume</a>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: ["projectCb"],
  methods: {
    proj: function() {
      this.projectCb();
    }
  }
};
</script>

<style lang="scss">
@import "./Menu.scss";
</style>